// Accounting › Agent requests (Blueprint's; the owner-agents prototype), its own module out of Books.tsx,
// on ui-web's ListPage (patterns/README.md, BL-189): what the agents asked to do in the books, Waiting,
// Approved or Declined (the views). The requests are shared/ApprovalRequests.tsx's, narrowed to the books'
// own; Inbox › Agents and approvals draws the same list with every request. Riverstone keeps
// shared/ApprovalsInbox.tsx.
import { ListPage } from '@flowology/ui-web/patterns';
import { PageBanners, usePageCrumb, type NavProps } from '../Nav.tsx';
import { useApprovalRequests } from '../shared/ApprovalRequests.tsx';
import { isBooksRequest } from './model.ts';
import { BOOKS_PARTS } from './parts.ts';

const PART = BOOKS_PARTS.find((p) => p.part === 'approvals')!;

export function ApprovalsPage({
  nav,
  toast,
  timeZone,
}: {
  nav: NavProps;
  /** The permissions the person holds: who may decide is the server's (cannotDecide). */
  held?: readonly string[];
  toast: (m: string) => void;
  timeZone?: string;
}) {
  const requests = useApprovalRequests({ toast, filter: isBooksRequest, ...(timeZone ? { timeZone } : {}) });
  const crumb = usePageCrumb(nav);
  return (
    <div className="app">
      <main>
        <PageBanners nav={nav} />
        <ListPage
          head={{ ...(crumb ? { crumb } : {}), title: PART.bp ?? PART.rail, lede: PART.lede }}
          {...requests}
        />
      </main>
    </div>
  );
}
